import type { ParentComponent } from 'solid-js'
import { css, cx } from 'styled-system/css'
import type { CardVariantProps } from 'styled-system/recipes'

export const Paper: ParentComponent<
  CardVariantProps & {
    class?: string
    noPadding?: boolean
    noBorder?: boolean
  }
> = (props) => {
  const { noBorder, noPadding, children, ...rest } = props

  return (
    <div
      class={cx(
        props.class,
        css({
          boxShadow: 'none',
          borderRadius: 'l2',
          p: noPadding ? 0 : 3,
          border: noBorder ? 'none' : 'solid 1px var(--colors-gray-4)',
        }),
      )}
    >
      {props.children}
    </div>
  )
}
